import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { Eye } from 'lucide-react';

const ArticleCard = ({ article, index = 0, layout = 'grid' }) => {
  const formattedDate = article.published_at 
    ? format(new Date(article.published_at), 'MMM d, yyyy')
    : 'Draft';

  const articleUrl = `/article/${article.slug || article.id}`;
  const staggerClass = `stagger-${Math.min(index + 1, 8)}`;

  if (layout === 'row') {
    return (
      <Link 
        to={articleUrl}
        className={`block group animate-fade-in-up ${staggerClass}`}
        data-testid={`article-card-${article.id}`}
      >
        <article className="bg-[#111] border border-[#222] hover:border-yellow-500/50 hover-lift transition-all duration-300 overflow-hidden flex flex-row">
          {article.featured_image && (
            <div className="w-36 h-20 sm:w-44 sm:h-24 flex-shrink-0 overflow-hidden">
              <img
                src={article.featured_image}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                loading="lazy"
              />
            </div>
          )}
          <div className="p-3 flex flex-col justify-center min-w-0 flex-1">
            <h3 className="text-white text-sm sm:text-lg font-bold leading-tight group-hover:text-yellow-500 transition-colors duration-200 line-clamp-2">
              {article.title}
            </h3>
            <div className="flex items-center gap-3 mt-1.5 text-[11px] text-gray-600">
              <span>{formattedDate}</span>
              <span className="flex items-center gap-0.5 text-green-500">
                <Eye size={10} />
                {article.views || 0}
              </span>
            </div>
          </div>
        </article>
      </Link>
    );
  }

  return (
    <Link 
      to={articleUrl}
      className={`block h-full group animate-fade-in-up ${staggerClass}`}
      data-testid={`article-card-${article.id}`}
    >
      <article className="h-full bg-[#111] border border-[#222] hover:border-yellow-500/50 hover-lift transition-all duration-300 overflow-hidden">
        {article.featured_image && (
          <div className="aspect-[4/3] overflow-hidden">
            <img
              src={article.featured_image}
              alt={article.title}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              loading="lazy"
            />
          </div>
        )}
        <div className="p-1 sm:p-2">
          <h3 className="text-[10px] sm:text-xs md:text-sm text-white font-bold leading-tight group-hover:text-yellow-500 transition-colors duration-200 line-clamp-2">
            {article.title}
          </h3>
          <div className="mt-1 flex items-center justify-between gap-1 text-[8px] text-gray-600 sm:text-[10px]">
            <span>{formattedDate}</span>
            <span className="flex items-center gap-0.5 text-green-500">
              <Eye size={8} />
              {article.views || 0}
            </span>
          </div>
        </div>
      </article>
    </Link>
  );
};

export default ArticleCard;
